export default __webpack_public_path__ + "xing-logo.png";